// import config from "@/config";
import telematicsService from "../../api/telematics.service";
import locationService from "../../api/location.service";
import moment from "moment";
import XLSX from "xlsx";

export default {
  name: "trips",
  components: {},
  props: ["respData"],
  data() {
    return {
      search: "",
      isTripsLoading: false,
      loading: false,
      dateCheck: true,
      dateErrorMsg: "",
      dateErrorMsgmax: "",
      options: {
        zoomControl: true,
        fullscreenControl: true,
        disableDefaultUI: true,
        scrollwheel: true,
        mapTypeControl: true,
        scaleControl: true,
        streetViewControl: true,
        rotateControl: true,
        styles: [
          {
            elementType: "geometry",
            stylers: [
              {
                color: "#f5f5f5",
              },
            ],
          },
          {
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#000339",
              },
            ],
          },
          {
            elementType: "labels.text.stroke",
            stylers: [
              {
                color: "#f7f7f8",
              },
            ],
          },
          {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#bdbdbd",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "geometry",
            stylers: [
              {
                color: "#eeeeee",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "poi.business",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [
              {
                color: "#e5e5e5",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [
              {
                color: "#ffffff",
              },
            ],
          },
          {
            featureType: "road.arterial",
            elementType: "labels",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "road.arterial",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#757575",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [
              {
                color: "#dadada",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "labels",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#616161",
              },
            ],
          },
          {
            featureType: "road.local",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
          {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [
              {
                color: "#e5e5e5",
              },
            ],
          },
          {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [
              {
                color: "#eeeeee",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                color: "#c9c9c9",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#89a9c8",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [
              {
                color: "#9e9e9e",
              },
            ],
          },
        ],
      },
      defaultValue: null,
      tripsList: [],
      address: "",

      responseData: {},
      headerTrips: [
        {
          text: "#",
          align: "center",
          sortable: false,
          value: "sno",
        },
        { text: "Time", value: "time" },
        // { text: "Address", value: "streetAddress" },
        { text: "Latitude", value: "latitude" },
        { text: "Longitude", value: "longitude" },
      ],
      locationDetails: {},
      infowindowdiv: false,
      center: {},
      userCurrentLocation: {},
      waypnt: [],
      zoom: 20,
      svgMarkerBlue: {
        url: require("../../assets/pin-blue-35.png"),
        // path: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
        fillColor: "#333399",
        fillOpacity: 1,
        strokeWeight: 0,
        rotation: 0,
        scale: 2,
        labelOrigin: { x: 60, y: 45 },
      },
      svgMarkerGreen: {
        path: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
        fillColor: "#097969",
        fillOpacity: 1,
        strokeWeight: 0,
        rotation: 0,
        scale: 2,
        labelOrigin: { x: 35, y: 9 },
      },
      svgMarkerRed: {
        path: "M624.617,303.323c0,0,42.016,2.791,44.807,47.606c0,0,36.396-77.03,109.23-23.809h19.598C798.25,327.122,747.848,192.696,624.617,303.323z",
        fillColor: "#FF0000",
        fillOpacity: 1,
        strokeWeight: 0,
        rotation: 0,
        scale: 2,
        labelOrigin: { x: 35, y: 9 },
      },
      svgMarkerCluster: {
        // path: "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z",
        url: require("../../assets/icons8-location-24.png"),
        fillColor: "#097969",
        fillOpacity: 1,
        strokeWeight: 0,
        rotation: 0,
        labelOrigin: { x: 35, y: 9 },
        scale: 2,
        // size: { width: 15, height: 15, f: "px", b: "px" },
        // scaledSize: { width: 15, height: 15, f: "px", b: "px" },
      },
      menu1: false,
      menu2: false,
      date: moment().subtract(1, "days").format("YYYY-MM-DD"),
      prevdate: moment().subtract(2, "days").format("YYYY-MM-DD"),
      prevdate10: moment().subtract(10, "days").format("YYYY-MM-DD"),
      prevdate7: moment().subtract(7, "days").format("YYYY-MM-DD"),

      nowDate: moment().subtract(1, "days").format("YYYY-MM-DD"),

      selectedDate: moment().subtract(1, "days").format("MM/DD/YYYY"),
      dateMax: true,
    };
  },
  filters: {
    formatDate: function (value) {
      if (value) {
        const format = "MM/DD/YYYY hh:mm:ss A";
        return moment(value).format(format);
      }
    },
    formattoLocalDate: function (value) {
      if (value) {
        const format = "MM/DD/YYYY hh:mm:ss A";
        return moment.utc(value).local().format(format);
      }
    },
  },
  computed: {},
  created() {
    this.responseData = this.respData;
    this.geolocate();
    this.getUnitHistory();
    // if (this.responseData == "Trackunit") {
    // }
  },
  mounted() {},
  methods: {
    disablePastDates(val) {
      // return val >= this.nowDate && val > this.prevdate10;
      return val <= new Date().toISOString().substr(0, 10);
    },
    datesCompare() {
      if (this.prevdate7 && this.date) {
        let dateCheck =
          moment(this.date).format("YYYY-MM-DD") >=
          moment(this.prevdate7).format("YYYY-MM-DD");
        this.dateCheck = dateCheck;

        if (!this.dateCheck) {
          this.dateErrorMsg = "To Date should be greater than From Date";
        }
        let maxdays = moment(this.date).diff(moment(this.prevdate7), "days");
        this.dateMax = maxdays < 10;
        if (!this.dateMax) {
          this.dateErrorMsgmax = "Only 10 days timeframe is allowed";
        }
      }
    },
    // load initial Google Maps with user's current location
    geolocate: function () {
      navigator.geolocation.getCurrentPosition((position) => {
        this.userCurrentLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },
    clearFilter() {
      this.date = moment().subtract(1, "days").format("YYYY-MM-DD");
      this.prevdate = moment().subtract(2, "days").format("YYYY-MM-DD");
      (this.prevdate7 = moment().subtract(7, "days").format("YYYY-MM-DD")),
        (this.dateCheck = true);
      this.dateMax = true;
      this.getUnitHistory();
    },
    async getUnitHistory() {
      // if (this.responseData == "Trackunit") {
      this.isTripsLoading = true;
      this.tripsList = [];
      this.waypnt = [];
      this.excelList = [];
      try {
        let response = await telematicsService.getUnitHistoryNew(
          this.$route.params.assetId,
          this.prevdate7,
          this.date,
          this.responseData ? this.responseData.contractId : ""
        );
        if (response && response.data) {
          if (response.data.length > 0) {
            this.tripsList = response.data;
            for (let m = 0; m < this.tripsList.length; m++) {
              this.tripsList[m]["sno"] = m + 1;
              this.tripsList[m]["order"] = m.toString();
              this.waypnt.push({
                lat: this.tripsList[m].latitude,
                lng: this.tripsList[m].longitude,
              });
              this.excelList.push({
                latitude: this.tripsList[m].latitude,
                longitude: this.tripsList[m].longitude,

                time: this.tripsList[m].time
                  ? moment
                      .utc(this.tripsList[m].time)
                      .local()
                      .format("MM/DD/YYYY hh:mm:ss A")
                  : "",
              });
            }
            this.zoom = 15;
            this.center = {
              lat: this.tripsList[0].latitude,
              lng: this.tripsList[0].longitude,
            };
            let distance = this.getDistanceFromLatLonInKm(
              this.tripsList[0].latitude,
              this.tripsList[0].latitude,
              this.tripsList[this.tripsList.length - 1].latitude,
              this.tripsList[this.tripsList.length - 1].latitude
            );
            if (distance >= 20 && distance < 40) {
              this.zoom = 12;
            } else if (distance >= 40 && distance < 60) {
              this.zoom = 10;
            } else if (distance >= 60 && distance < 80) {
              this.zoom = 8;
            } else if (distance >= 80) {
              this.zoom = 6;
            }
          } else {
            this.zoom = 4.6;
            if (this.userCurrentLocation.lat && this.userCurrentLocation.lng) {
              this.center = this.userCurrentLocation;
            } else {
              this.center = { lat: 39.106667, lng: -94.676392 };
            }
          }
          this.isTripsLoading = false;
        } else {
          this.zoom = 4.6;
          if (this.userCurrentLocation.lat && this.userCurrentLocation.lng) {
            this.center = this.userCurrentLocation;
          } else {
            this.center = { lat: 39.106667, lng: -94.676392 };
          }
          this.isGettingTrips = false;
          this.$toast.error(response.systemMessage);
        }
      } catch (err) {
        this.zoom = 4.6;
        if (this.userCurrentLocation.lat && this.userCurrentLocation.lng) {
          this.center = this.userCurrentLocation;
        } else {
          this.center = { lat: 39.106667, lng: -94.676392 };
        }
        this.isTripsLoading = false;
        this.$toast.error("Unable to get trips data" + err);
      }
      // }
    },
    async getAddressFromLatLng(item) {
      let lat = item.latitude;
      let lng = item.longitude;
      this.address = "";
      if (lat && lng) {
        this.loading = true;
        try {
          let response = await locationService.getAddressByLatitudeAndLongitude(
            "birch",
            lat,
            lng
          );
          if (response && response.data && response.isSuccess) {
            this.loading = false;

            if (response.data.streetAddress) {
              this.address = response.data.streetAddress;
              if (
                response.data.city ||
                response.data.state ||
                response.data.zipCode ||
                response.data.country
              ) {
                this.address = this.address + ", ";
              }
            }
            if (response.data.city) {
              this.address = this.address + response.data.city;
              if (
                response.data.state ||
                response.data.zipCode ||
                response.data.country
              ) {
                this.address = this.address + ", ";
              }
            }
            if (response.data.state) {
              this.address = this.address + response.data.state;
              if (response.data.zipCode) {
                this.address = this.address + " ";
              } else if (response.data.country) {
                this.address = this.address + ", ";
              }
            }
            if (response.data.zipCode) {
              this.address = this.address + response.data.zipCode;
              if (response.data.country) {
                this.address = this.address + ", ";
              }
            }
            if (response.data.country) {
              this.address = this.address + response.data.country;
            }
          } else {
            this.loading = false;
            this.$toast.error(response.systemMessage);
            this.geolocate();
          }
        } catch (err) {
          console.log(err);
          this.$toast.error("Unable to get address" + err);
          this.loading = false;
          this.geolocate();
        }
      } else {
        this.geolocate();
      }
    },
    getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
      var R = 6371; // Radius of the earth in km
      var dLat = this.deg2rad(lat2 - lat1); // deg2rad below
      var dLon = this.deg2rad(lon2 - lon1);
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.deg2rad(lat1)) *
          Math.cos(this.deg2rad(lat2)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var d = R * c; // Distance in km
      return d;
    },

    deg2rad(deg) {
      return deg * (Math.PI / 180);
    },
    openWindowdiv(item) {
      this.getAddressFromLatLng(item);
      this.infowindowdiv = true;
      this.locationDetails = item;
    },
    exportToExcel() {
      this.excelHeader = [];
      this.startrow = 3;
      this.excelHeader.push(["Trips"]);
      if (this.responseData.unitId) {
        this.startrow += 1;
        this.excelHeader.push([
          "Unit Name:" + " " + this.responseData.displayName,
        ]);
      }
      if (this.date) {
        this.startrow += 1;
        this.excelHeader.push(["Date:" + " " + this.date]);
      }
      this.excelHeader.push([]);
      this.startrow += 1;
      this.excelHeader.push(["Latitude", "Longitude", "Address", "Time"]);
      let tempExcel = this.excelList.map(function (item) {
        return item;
      });
      let datarow = "A" + this.startrow;
      var ws = XLSX.utils.aoa_to_sheet(this.excelHeader);
      XLSX.utils.sheet_add_json(ws, tempExcel, {
        header: ["latitude", "longitude", "address", "time"],
        skipHeader: true,
        origin: datarow,
      });
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Trips");
      this.excelHeader = [];
      XLSX.writeFile(wb, "Trips.xlsx");
    },
  },
};
